import { Button, Container, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { ReactComponent as WelcomeImage } from "assets/svg/WelcomeImage.svg";
import CreateAccountDialog from "dialogs/CreateAccountDialog";
import LoginDialog from "dialogs/LoginDialog";
import { Colors } from "helpers/Consts";
import { useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import logger from "../../components/Logger";
import { ICardapioAppState } from "../../redux/RootReducer";

function Initial() {
  const { search } = useLocation()
  const [open, setOpen] = useState<boolean>(false);
  const [openCreateAccount, setOpenCreateAccount] = useState<boolean>(false);
  const placeInfo = useSelector((state: ICardapioAppState) => state?.placeInfo);

  const handleDialog = () => {
    return setOpen(!open);
  };
  const handleDialogCreateAccount = () => {
    return setOpenCreateAccount(!openCreateAccount);
  };
  return (
    <>
      <LoginDialog open={open} handleClose={handleDialog} />
      <CreateAccountDialog
        open={openCreateAccount}
        handleClose={handleDialogCreateAccount}
      />
      <Container sx={{ height: "100vh", marginTop: { md: 8 } }} maxWidth="lg">
        <Box p={2}>
          <Box
            paddingTop={"10px"}
            display={"flex"}
            sx={{ alignItems: "center", justifyContent: "center" }}
          >
            <Box
              component="img"
              sx={{ height: "100px" }}
              src={require("assets/img/main_logo.png")}
              alt="Avatar"
            />
          </Box>
          <Box
            paddingTop={3}
            display="flex"
            sx={{ alignItems: "center", justifyContent: "center" }}
          >
            <WelcomeImage height="22vh" width="70vw" />
          </Box>
          <Typography
            p={2}
            color={Colors.baseTextColor}
            style={{ fontWeight: 700 }}
            fontSize="10px"
            textAlign="center"
          >
            Encontre mais perto de você, monte sua sacola e receba seus pedidos
            onde voce estiver.
          </Typography>
          <Box>
            <Button
              color="primary"
              variant="contained"
              fullWidth
              sx={{ color: "white" }}
              onClick={handleDialogCreateAccount}
            >
              Criar minha conta
            </Button>

            <Button
              color="primary"
              variant="outlined"
              fullWidth
              sx={{ marginTop: 1 }}
              onClick={handleDialog}
            >
              Entrar na minha conta
            </Button>
          </Box>
          <Link
            to={`/${search}`}
            style={{ textDecoration: "none" }}
          >
            <Typography
              p={2}
              color={Colors.orangePrimary}
              style={{ fontWeight: 700 }}
              fontSize="10px"
              textAlign="center"
              sx={{
                textDecoration: "none",
              }}
            >
              Quero apenas explorar o aplicativo
            </Typography>
          </Link>
        </Box>
      </Container>
    </>
  );
}

export default Initial;
